var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 6.66668L9.33319 4.00001M1.6665 14.3333L3.92275 14.0826C4.19841 14.052 4.33624 14.0367 4.46507 13.995C4.57936 13.958 4.68814 13.9057 4.78843 13.8396C4.90147 13.765 4.99953 13.667 5.19565 13.4709L13.9999 4.66668C14.7362 3.9303 14.7362 2.73639 13.9999 2.00001C13.2635 1.26363 12.0696 1.26363 11.3332 2.00001L2.52899 10.8042C2.33287 11.0003 2.23481 11.0984 2.16026 11.2114C2.09413 11.3117 2.04185 11.4205 2.00485 11.5348C1.96314 11.6636 1.94783 11.8014 1.9172 12.0771L1.6665 14.3333Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilBlack);
export default __webpack_public_path__ + "static/media/pencil-black.2a4607052c7e4c5d1ccdf4991d597016.svg";
export { ForwardRef as ReactComponent };